import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { setChartOption } from './chart-options.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
export const useEstimates = createReducer(false, on(setChartData, (state, { chartData }) => chartData.params.useEstimates), on(setChartOption, (state, action) => {
    if (action.chartOption.value === FundChartOptionValue.SHOW_FORWARD_ESTIMATES) {
        return action.chartOption.selected;
    }
    return state;
}), on(setFundChart, (state, action) => {
    return action.fundChart[FundChartOptionValue.SHOW_FORWARD_ESTIMATES];
}));
